"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const reactflow_1 = require("reactflow");
const images_1 = require("../../../../assets/images");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const scale_1 = require("../../../../utils/scale");
exports.default = (0, react_1.memo)((props) => {
    const { data, isConnectable } = props;
    const NODE_SIZE = data.radius * 2;
    return (react_1.default.createElement(react_native_1.View, { style: { position: 'relative', width: 1, height: 1, backgroundColor: 'blue', overflow: 'visible' } },
        react_1.default.createElement(react_native_1.Pressable, { style: [
                styles.node,
                {
                    width: NODE_SIZE,
                    height: NODE_SIZE,
                    top: -NODE_SIZE / 2,
                    left: -NODE_SIZE / 2
                },
                { borderColor: data.color },
                data.stage == 0 && { padding: (0, scale_1.scale)(8) },
                data.has_children == 1 && { borderStyle: 'dashed' }
            ], onPress: () => {
                new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.MIND_MAP_NODE_PRESS, data.article_id);
            } },
            react_1.default.createElement(react_native_1.View, { style: [styles.body, { backgroundColor: data.color }] },
                react_1.default.createElement(react_native_1.Image, { source: !!data.user_thumbnail_url ?
                        { uri: data.user_thumbnail_url }
                        :
                            images_1.images.AvatarDefaul, style: [styles.avatar, {
                            width: (0, scale_1.scale)(NODE_SIZE * 0.25),
                            height: (0, scale_1.scale)(NODE_SIZE * 0.25),
                        }] }),
                react_1.default.createElement(CustomText_1.default, { numberOfLines: 3, style: [styles.title, {
                            fontSize: (0, scale_1.moderateScale)(NODE_SIZE / 19.25),
                            lineHeight: (0, scale_1.moderateScale)(NODE_SIZE / 12.833)
                        }] }, data.title))),
        react_1.default.createElement(reactflow_1.Handle, { type: "target", position: reactflow_1.Position.Top, isConnectable: isConnectable, style: { ...styles.handle } }),
        react_1.default.createElement(reactflow_1.Handle, { type: "source", position: reactflow_1.Position.Top, isConnectable: isConnectable, style: { ...styles.handle } })));
});
const styles = react_native_1.StyleSheet.create({
    node: {
        position: 'absolute',
        borderWidth: (0, scale_1.scale)(2),
        borderRadius: 999,
        padding: (0, scale_1.scale)(4),
    },
    body: {
        flex: 1,
        borderRadius: 999,
        padding: (0, scale_1.scale)(12),
        justifyContent: 'center',
        alignItems: 'center',
    },
    avatar: {
        // width: scale(28),
        // height: scale(28),
        borderRadius: 999,
    },
    title: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(8),
        lineHeight: (0, scale_1.moderateScale)(12),
        color: '#FFFFFF',
        textAlign: 'center'
    },
    handle: {
        position: "absolute",
        opacity: 0,
    }
});
